import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Table } from "./Table";

export const LegalDocumentsList = () => {
    const toast = useRef<any>(null);
    return (
        <>
            <Table toast={toast} />
            <Toast ref={toast} />
        </>
    );
}